module.exports = __webpack_public_path__ + "static/media/productividad.0f9c9bfd.svg";